import React from 'react';

import Text from 'v3/components/Text';
import Tooltip from 'v3/components/Tooltip';

import { ICONS, formatLogDate, getIntegrationLogMessage, getIntegrationLogVariant } from '../utils';
import * as Styled from './styles';

function IntegrationLogItem({ log }) {
  const { variant, label } = getIntegrationLogVariant(log);
  const Icon = ICONS[variant];

  return (
    <Styled.Item>
      <Tooltip content={label}>
        <Styled.IconWrapper $variant={variant} role="img" aria-label={label}>
          <Icon />
        </Styled.IconWrapper>
      </Tooltip>
      <Styled.Content>
        <Text type="label" color="dark">
          {formatLogDate(log.createdAt)}
        </Text>
        <Styled.Message>
          <Text type="regular" color="gray">
            {getIntegrationLogMessage(log, variant)}
          </Text>
        </Styled.Message>
      </Styled.Content>
    </Styled.Item>
  );
}

export default IntegrationLogItem;
